<template>
  <div class="quote-bg">
    <div>
      <a href="https://energieagentur-sg.ch" target="_blank">
        <img src="~@/assets/img/energieagentur-white.svg" alt="Logo" class="logo">
      </a>
      <b-container>
        <b-row>
          <b-col>
            <h1>Das<br/> Energieförderportal<br/> für St.Gallen</h1>
            <p>Der Kanton St.Gallen und die Mehrheit der Gemeinden fördern eine Vielzahl von Massnahmen und Aktivitäten zum Erreichen der Klimaziele. Die Energieagentur St.Gallen unterstützt Sie bei Ihren Projekten.</p>
          </b-col>
        </b-row>
      </b-container>
      <b-container v-if="new Date() >= new Date('2027-01-01')">
        <a href="https://energiekongress.ch/?utm_source=efoerderportal.sg.ch&utm_medium=banner&utm_campaign=energiekongress_2027" target="_blank">
          <img src="~@/assets/img/EASG_Energiekongress_2027.jpg" alt="Energiekongress" class="img-fluid">
        </a>
      </b-container>
    </div>
  </div>
</template>

<script>
  export default {

  }
</script>

<style lang="scss" scoped>
  .quote-bg{
    background: no-repeat bottom left $black-80;
    color: $white;
    position: relative;
    height: 100%;
    font-size: $h2-font-size;
    // padding: 8.5rem 2rem 9rem; without ena banner
    padding: 8.5rem 2rem 3rem;

    h1{
      font-size: $font-size-base * 3.5;
      font-weight: bold;
      color: $white;
      margin-bottom: 2rem;
    }

    p{
      line-height: 2;
    }
  }

  .logo{
    width: 193px;
    height: 85px;
    position: absolute;
    right: 3rem;
    top: 3rem;

    @include media-breakpoint-down(sm) {
      display: none;
    }
  }
</style>
